export default __webpack_public_path__ + "static/media/ic-remarketing.301dc950.svg";